import { Component, Prop, Vue } from "vue-property-decorator";
import firebase from "firebase/app";
import moment from "moment";
import { firebaseDB } from "@/plugins/firebase";
import { Chat } from "../../models/Chat.Model";
import { LOCAL_STORAGE } from "@/shared/constants/FormConstants";
import { Message } from "../../models/Message.Model";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  CHATS_FIELDS,
  FIREBASE_COLLECTIONS,
  FIREBASE_EVENTS,
  LOCAL_CHAT_TYPE
} from "../../constants/LocalChatWindow.constants";

// TODO: Refactor y agregar constantes

@Component
export default class SingleChat extends Vue {
  @Prop({ required: true }) private chat!: Chat;
  private clientId!: string;
  private userId!: string;
  private chatsRef!: firebase.firestore.CollectionReference;
  private messageRef!: firebase.firestore.CollectionReference;
  private userRef!: firebase.firestore.CollectionReference;
  private newMessage = "";
  private messages: Message[] = [];
  private userNames: Record<string, string> = {};
  private unsubscribe!: () => void;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;

  mounted() {
    this.userId = localStorage.getItem(LOCAL_STORAGE.UID) || "";
    this.clientId = localStorage.getItem(LOCAL_STORAGE.CLIENT_ID) || "";
    if (this.clientId) {
      this.userRef = this.getCollectionReference(FIREBASE_COLLECTIONS.USERS);
      this.chatsRef = this.getCollectionReference(FIREBASE_COLLECTIONS.CHATS);
      this.messageRef = this.getCollectionReference(
        FIREBASE_COLLECTIONS.MESSAGES,
        this.chat.id
      );
      this.updateChatLastSeen();
      this.getMessages();
    }
  }

  private getCollectionReference(collection: string, docId?: string) {
    const baseRef = firebaseDB
      .collection(FIREBASE_COLLECTIONS.CLIENTS)
      .doc(this.clientId)
      .collection(collection);
    return docId
      ? baseRef.doc(docId).collection(FIREBASE_COLLECTIONS.MESSAGES)
      : baseRef;
  }

  private scrollToBottom() {
    this.$nextTick(() => {
      const container = document.getElementById("msg-container");
      if (container) container.scrollTop = container.scrollHeight;
    });
  }

  private async fetchSenderName(senderId: string): Promise<string> {
    if (!this.userNames[senderId]) {
      const userDoc = await this.userRef.doc(senderId).get();
      this.userNames[senderId] = userDoc.data()?.visualName || "";
    }
    return this.userNames[senderId];
  }

  private async processMessage(change: firebase.firestore.DocumentChange) {
    const message = change.doc.data() as Message;
    message.id = change.doc.id;
    message.dateText = moment(message.dateSent)
      .locale("es")
      .fromNow();

    if (this.chat.type === LOCAL_CHAT_TYPE.GROUP) {
      message.senderName = await this.fetchSenderName(message.senderId);
    }

    if (!message.seenBy.includes(this.userId)) {
      this.messageRef.doc(change.doc.id).update({
        seenBy: firebase.firestore.FieldValue.arrayUnion(this.userId)
      });
      message.seenBy.push(this.userId);
    }

    message.seen = message.seenBy.some(id => id !== this.userId);

    if (change.type === FIREBASE_EVENTS.ADDED) {
      this.messages.push(message);
    } else if (change.type === FIREBASE_EVENTS.MODIFIED) {
      const index = this.messages.findIndex(m => m.id === message.id);
      if (index !== -1) this.messages[index] = message;
    }
  }

  private getMessages() {
    try {
      this.messages = [];
      this.unsubscribe = this.messageRef
        .orderBy(CHATS_FIELDS.DATE_SENT, "asc")
        .onSnapshot(async snapshot => {
          for (const change of snapshot.docChanges()) {
            await this.processMessage(change);
          }
          this.scrollToBottom();
          this.updateChatLastSeen();
        });
    } catch (error) {
      console.error("Error al obtener mensajes:", error);
    }
  }

  private updateChatLastSeen() {
    this.chatsRef.doc(this.chat.id).update({
      seenBy: firebase.firestore.FieldValue.arrayUnion(this.userId)
    });
  }

  sendMessage(): void {
    if (this.newMessage.trim()) {
      const message = {
        senderId: this.userId,
        content: this.newMessage,
        type: "text",
        dateSent: Date.now(),
        seenBy: []
      };
      this.messageRef.add(message);
      this.chatsRef.doc(this.chat.id).update({
        lastMessage: message.content,
        dateLastMessage: message.dateSent,
        seenBy: []
      });
      this.newMessage = "";
    }
  }

  goBack() {
    this.$emit("goBack");
  }

  beforeDestroy() {
    if (this.unsubscribe) this.unsubscribe();
  }
}
